export const AFFILIATE_APPLICATION_FORM_URL = 'https://dotcampusafrica.zohothrive.eu/thrive/publicpages/affiliate-registration/dotcampusafrica/d207d2dbb3f0cf43323793daeb32c88289554084e92ffdc579e2c1660befc816'

export const affiliateInfo = [
  {
    question: 'How does the DotCampus Affiliate Program work?',
    answer:
      "Once you sign up, you'll receive a unique affiliate link. When someone enrolls in a DotCampus course using your link, you earn a 10% commission on their purchase.",
  },
  {
    question: 'Who can join the affiliate program?',
    answer:
      "Anyone! Whether you're a content creator, educator, blogger, or just someone who loves sharing valuable learning opportunities, you can sign up and start earning.",
  },
  {
    question: 'How do I track my referrals and earnings?',
    answer:
      "You'll have access to an affiliate dashboard where you can track clicks, conversions, and commissions in real-time.",
  },
  {
    question: 'When and how do I get paid?',
    answer:
      "Commissions are paid monthly via PayPal or Bank Transfer, as long as you've reached the minimum payout threshold.",
  },
  {
    question: 'Is there a limit to how much I can earn?',
    answer:
      "Nope! The more you refer, the more you earn. There's no cap on your earnings.",
  },
  {
    question: ' How do I get started?',
    answer:
      "Just sign up, get your unique link, and start sharing. It's that easy!",
    link: {
      text: 'Signup Now!',
      href: AFFILIATE_APPLICATION_FORM_URL,
      isExternal: true,
    },
  },
]
